module.exports = __webpack_public_path__ + "img/grey.9d2c469.svg";